import { MasterDataContainer } from '../../dataAccess/masterDataContainer';
import { KbnInfoCacheViewModel } from './kbnInfoCacheViewModel';

export class KbnInfoCacheContainer extends MasterDataContainer<KbnInfoCacheViewModel> {
    constructor(models: Array<KbnInfoCacheViewModel>, dataYear: number, version: Date) {
        super(models, dataYear, version);
    }
}
